import Clip from './clip.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.clip = function () {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(Clip);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })
        // }

        vueInstance.wrapshow = true
        return vueInstance.show(...arguments)
    }
}

export default Plugin;